import { render, staticRenderFns } from "./FormMealBlockItemSettings.vue?vue&type=template&id=7019b6d3"
import script from "./FormMealBlockItemSettings.vue?vue&type=script&lang=js"
export * from "./FormMealBlockItemSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports